<script>
  import {mapActions, mapGetters} from 'vuex';
  import flags from './flags';

  export default {
    components: {
      flags
    },
    computed: {
      ...mapGetters(['loggedUser', 'isLogged'])
    },
    methods: {
      ...mapActions(['logout']),
      toggleUserMenu () {
        this.isOpenUser = !this.isOpenUser
      },
      doLogout () {

        this.logout().then(() => {

          this.$router.push({path: '/auth'});

        });
      },
      setPtBr: function() {
        this.$i18n.locale = 'pt';
      },
      setEn: function() {
        this.$i18n.locale = 'en';
      },
      setEs: function() {
        this.$i18n.locale = 'es';
      }
    }
  }

</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <span class="pull-right">
          <ul class="menu-1">
            <li>
              <flags/>
            </li>
            <li v-if="isLogged" class="border-left-padding-left-10px">
              <el-dropdown>
                  <span class="el-dropdown-link">
                    <i class="glyphicon glyphicon-user"></i>
                    <b v-if="loggedUser.username === 'admin'">{{ loggedUser.username }}</b>
                    <b v-else>{{ loggedUser.name }}</b>
                    <i class="glyphicon glyphicon-option-vertical"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">

                    <router-link :to="{ name: 'UserProfile'}" tag="a" exact>
                      <el-dropdown-item v-if="loggedUser.username !== 'admin'">
                        {{ $t("profile") }}
                      </el-dropdown-item>
                    </router-link>
                    <el-dropdown-item divided v-if="loggedUser.username !== 'admin'"  >

                    </el-dropdown-item>
                    <a href="#" @click.prevent="doLogout">
                      <el-dropdown-item>
                        {{$t("logout")}}
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
            </li>
          </ul>
        </span>
      </div>
    </div>
  </div>
</template>

<style>
.el-dropdown-link {
  cursor: pointer;
}
.border-left-padding-left-10px{
    border-left: 1px solid #C8C8C8;
    padding-left: 10px;
}
.padding-right-20px {
    padding-right: 20px;
}
.padding-12px {
    padding: 12px;
}
.border-left-1px {
  border-left: 1px solid #C8C8C8;
}
.padding-17px-0{
  padding: 17px 0;
}
.padding-left-10px {
  padding-left: 10px;
}
.padding-right-10px {
  padding-right: 10px
}





</style>



// WEBPACK FOOTER //
// menuUser.vue?9807e1d4